module.exports = __webpack_public_path__ + "assets/tripadvisor-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/tripadvisor-logo.png
// module id = 1210
// module chunks = 7